import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, POST, PUT, GET } from 'helpers/api'
import { regexPhoneNumber, formatMoney, formatDate } from 'helpers/helpers'

// Rasm manzili uchun backend origin (/api siz)
const IMG_BASE = process.env.NODE_ENV === 'production'
	? (process.env.REACT_APP_API_URL || 'https://backend.tameer.uz/api').replace(/\/api$/, '')
	: 'http://127.0.0.1:8000'

// Xodim rollari (kartada Bo'lim tagida).
// key = xodim kategoriyasi (employees.role da saqlanadi), role_name = tizim roli (login uchun, o'zgarmaydi)
const ROLES = [
	{ key: 'sotuvchi', label: 'Sotuvchi', role_name: 'ROLE_CASHIER' },
	{ key: 'kassir', label: 'Kassir', role_name: 'ROLE_CASHIER' },
	{ key: 'ishlab_chiqarish', label: 'Ishlab chiqarish xodimlari', role_name: 'ROLE_WORKSHOP' },
	{ key: 'ishlab_chiqarish_rahbari', label: 'Ishlab chiqarish rahbari', role_name: 'ROLE_PROD_MANAGER' },
	{ key: 'omborchi', label: 'Omborchi', role_name: 'ROLE_WAREHOUSE' },
	{ key: 'direktor', label: 'Direktor', role_name: 'ROLE_DIRECTOR' },
	{ key: 'xaydovchi', label: 'Xaydovchi', role_name: 'ROLE_COURIER' },
]
const roleSystemName = (key) => (ROLES.find(r => r.key === key)?.role_name || null)

// PostgreSQL boolean'i drayverga qarab true / 't' / 'true' bo'lib kelishi mumkin
const isTrue = (v) => v === true || v === 't' || v === 'true'

// Kadrlardan yashirilgan xodimni KIM ko'radi va kim yoqib-o'chira oladi.
// Backend'dagi Helper::canSeeHiddenEmployees() bilan bir xil ro'yxat bo'lishi shart —
// bu yerda faqat ko'rinish, haqiqiy himoya backendda (403).
const CAN_SEE_HIDDEN = ['ROLE_OWNER', 'ROLE_DIRECTOR', 'ROLE_ADMIN']

// Modal ichidagi react-select menyusi qirqilmasligi uchun body'ga portal qilamiz
const SELECT_PORTAL = {
	menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
	styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
}

const ACCEPTED_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']
const MAX_UPLOAD_BYTES = 5 * 1024 * 1024   // 5MB
const TARGET_BYTES = 200 * 1024            // 200KB

// Brauzerda rasmni 200KB gacha siqadi, data-uri qaytaradi
function compressImage(file, maxDim = 800) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = (e) => {
			const img = new Image()
			img.onload = () => {
				let { width, height } = img
				if (width > maxDim || height > maxDim) {
					if (width > height) { height = Math.round(height * maxDim / width); width = maxDim }
					else { width = Math.round(width * maxDim / height); height = maxDim }
				}
				const canvas = document.createElement('canvas')
				canvas.width = width
				canvas.height = height
				const ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0, width, height)

				let quality = 0.9
				let dataUrl = canvas.toDataURL('image/jpeg', quality)
				while ((dataUrl.length * 0.75) > TARGET_BYTES && quality > 0.3) {
					quality -= 0.1
					dataUrl = canvas.toDataURL('image/jpeg', quality)
				}
				resolve(dataUrl)
			}
			img.onerror = reject
			img.src = e.target.result
		}
		reader.onerror = reject
		reader.readAsDataURL(file)
	})
}

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [employeeTypes, setEmployeeTypes] = useState([])
	const [departments, setDepartments] = useState([])   // chapdagi Bo'lim (faqat nom, HR)
	const [productTypes, setProductTypes] = useState([]) // sex Bo'limi (products_types, tizim)
	const [permissions, setPermissions] = useState([])

	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [photoError, setPhotoError] = useState('')
	const [filterData, setFilterData] = useState({ search: '' })
	const [pagination, setPagination] = useState({ url: '/employee-list', response: null })

	async function searchWithFilter() {
		var urlParams = ''
		if (filterData.search) urlParams += (urlParams ? '&' : '?') + 'search=' + filterData.search
		if (filterData.employee_type_id) urlParams += (urlParams ? '&' : '?') + 'employee_type_id=' + filterData.employee_type_id
		if (filterData.department_id) urlParams += (urlParams ? '&' : '?') + 'department_id=' + filterData.department_id
		if (filterData.page) urlParams += (urlParams ? '&' : '?') + 'page=' + filterData.page
		if (filterData.size) urlParams += (urlParams ? '&' : '?') + 'size=' + filterData.size

		const response = await GET('/employee-list' + urlParams, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, response: response.data })
		}
	}

	async function createUpdate(e) {
		e.preventDefault()

		const item = { ...selectedItem }
		// Login akkaunt uchun tizim roli (kategoriyadan): sotuvchi/kassir -> ROLE_CASHIER
		item.login_role = roleSystemName(item.role)
		// Ruxsatlar (Kassa, Smena...) FAQAT kassir/sotuvchi uchun. Boshqa rolda bo'sh
		// ketadi — aks holda rol o'zgartirilganda eski galochkalar yashirin qoladi.
		item.permissions = []
		if (roleSystemName(item.role) === 'ROLE_CASHIER') {
			for (let i = 0; i < permissions.length; i++) {
				for (let j = 0; j < permissions[i]['permissions'].length; j++) {
					if (permissions[i]['permissions'][j]['checked']) {
						item.permissions.push(permissions[i]['permissions'][j])
					}
				}
			}
		}
		// Ishlab chiqarish rahbari — nazorat qiladigan bo'limlar (product_types massivi)
		if (roleSystemName(item.role) === 'ROLE_PROD_MANAGER') {
			item.product_types = Array.isArray(item.product_types) ? item.product_types : []
		}

		var response
		if (item.id) {
			response = await PUT('/employee-list', item, { loader: true })
		} else {
			response = await POST('/employee-list', item, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal(false)
		}
	}

	async function deleteEmployee(item) {
		if (!window.confirm(item.name + ' — ' + t('delete') + '?')) return
		const response = await PUT('/employee-status', { id: item.id, status: -1 }, { loader: true })
		if (httpOk(response)) searchWithFilter()
	}

	// Kadrlardan yashirish / qaytarish. Faqat ega·direktor·admin (backend ham tekshiradi).
	async function toggleHidden(item) {
		const next = !isTrue(item.hidden_from_hr)
		const question = next
			? item.name + ' — ' + t('hide_from_hr') + '?\n\n' + t('hide_from_hr_hint')
			: item.name + ' — ' + t('unhide_from_hr') + '?'
		if (!window.confirm(question)) return
		const response = await PUT('/employee-hidden', { id: item.id, hidden: next }, { loader: true })
		if (httpOk(response)) searchWithFilter()
	}

	async function handlePhotoChange(e) {
		setPhotoError('')
		const file = e.target.files[0]
		if (!file) return
		if (!ACCEPTED_FORMATS.includes(file.type)) {
			setPhotoError('Format: jpeg, jpg, png, webp')
			return
		}
		if (file.size > MAX_UPLOAD_BYTES) {
			setPhotoError('Maksimal hajm: 5MB')
			return
		}
		try {
			const dataUrl = await compressImage(file)
			setSelectedItem((prev) => ({ ...prev, photo: dataUrl }))
		} catch (err) {
			setPhotoError('Rasmni o\'qib bo\'lmadi')
		}
	}

	function removePhoto() {
		setSelectedItem((prev) => ({ ...prev, photo: '' }))
	}


	async function toggleModal(bool = false, item = {}) {
		if (bool) {
			const copy = {
				salary_type: 1,
				monthly_salary: 0,
				has_login: !!item.has_login,
				role: item.user_role || null,
				...item,
			}
			// item.has_login PostgreSQL'dan 'true'/true bo'lishi mumkin
			copy.has_login = item.has_login === true || item.has_login === 't' || item.has_login === 'true'
			copy.role = item.role || item.user_role || null
			// Faqat avvaldan mavjud login qulflanadi (yangi yozilayotgani emas)
			copy.has_existing_login = !!item.user_login
			setSelectedItem(copy)
			await getPermissions(item.user_login || null)
		} else {
			setSelectedItem({})
			setPermissions([])
			setPhotoError('')
		}
		setShowModal(bool)
	}

	function selectAll(checked, catIndex) {
		const copy = [...permissions]
		for (let j = 0; j < copy[catIndex]['permissions'].length; j++) {
			copy[catIndex]['permissions'][j]['checked'] = checked
		}
		copy[catIndex]['checked'] = checked
		setPermissions(copy)
	}

	function selectOne(checked, catIndex, permIndex) {
		const copy = [...permissions]
		copy[catIndex]['permissions'][permIndex]['checked'] = checked
		setPermissions(copy)
	}

	async function getPermissions(userLogin = null) {
		const response = await GET('/helper/permissions', userLogin ? { user_login: userLogin } : {})
		if (httpOk(response)) setPermissions(response.data)
	}

	async function getEmployeeTypes() {
		const response = await GET('/helper/employees-types')
		if (httpOk(response)) setEmployeeTypes(response.data)
	}

	// Chapdagi Bo'lim (faqat nom, hech narsaga bog'lanmaydi)
	async function getDepartments() {
		const response = await GET('/helper/departments')
		if (httpOk(response)) setDepartments(response.data)
	}

	// Sex Bo'limi (products_types) — Ishlab chiqarish rahbari login uchun
	async function getProductTypes() {
		const response = await GET('/helper/products-types')
		if (httpOk(response)) {
			const EXCLUDED = ['Продукт', 'Рулон', 'Product', 'Rulon']
			setProductTypes(response.data.filter(d => !EXCLUDED.includes(d.name)))
		}
	}


	function paginate(page, size) {
		setFilterData({ ...filterData, page, size })
	}

	useEffect(() => {
		getEmployeeTypes()
		getDepartments()
		getProductTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.employee_type_id, filterData.department_id, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	const canSeeHidden = CAN_SEE_HIDDEN.includes(localStorage.getItem('role'))

	function initials(name) {
		if (!name) return '?'
		return name.trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase()
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('employees')} [{formatMoney(data?.total)}]
				</h4>
				<button className="btn-rounded btn btn-primary" onClick={() => toggleModal(true)}>
					<i className="uil-plus me-1"></i>{t('create')}
				</button>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3 flex-wrap gap-2">
						<FilterSearch filterData={filterData} setFilterData={setFilterData} />

						<div className="d-flex gap-2 flex-wrap">
							<div style={{ minWidth: '180px' }}>
								<Select
									isClearable
									options={departments}
									value={departments.find(o => o.id === filterData.department_id) || null}
									onChange={(opt) => setFilterData({ ...filterData, department_id: opt ? opt.id : undefined })}
									placeholder={"Barcha bo'limlar"}
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(o) => o.name}
									getOptionValue={(o) => o.id}
								/>
							</div>
							<div style={{ minWidth: '180px' }}>
								<Select
									isClearable
									options={employeeTypes}
									value={employeeTypes.find(o => o.id === filterData.employee_type_id) || null}
									onChange={(opt) => setFilterData({ ...filterData, employee_type_id: opt ? opt.id : undefined })}
									placeholder={'Barcha lavozimlar'}
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(o) => o.name}
									getOptionValue={(o) => o.id}
								/>
							</div>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th>{t('name2')}</th>
									<th>{t('position') || 'Lavozim'}</th>
									<th>{"Bo'lim"}</th>
									<th>{t('phone')}</th>
									<th className="text-center">{t('access') || 'Kirish'}</th>
									<th className="text-nowrap text-center">{t('date')}</th>
									<th style={{ minWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className="tr-middle">
										<td className="text-center">{item.row_number}</td>
										<td>
											<div className="d-flex align-items-center gap-2">
												{item.photo
													? <img src={`${IMG_BASE}/uploads/employees/${item.photo}`} alt=""
														style={{ width: 34, height: 34, borderRadius: '50%', objectFit: 'cover' }} />
													: <span className="d-flex align-items-center justify-content-center"
														style={{ width: 34, height: 34, borderRadius: '50%', background: 'var(--dk-surface-3, #e9ecef)', fontSize: 12, fontWeight: 600, color: '#6c757d' }}>
														{initials(item.name)}
													</span>
												}
												<span className="fw-semibold">{item.name}</span>
												{isTrue(item.hidden_from_hr) &&
													<span className="badge bg-secondary" title={t('hide_from_hr_hint')}>
														<i className="uil-eye-slash me-1"></i>{t('hidden_from_hr')}
													</span>
												}
											</div>
										</td>
										<td>{item.employee_type_name}</td>
										<td>{item.department_name}</td>
										<td className="text-nowrap">{regexPhoneNumber(item.phone)}</td>
										<td className="text-center">
											{item.has_login
												? <span className="badge bg-success" title={item.user_login}>
													<i className="uil-check me-1"></i>{item.user_login}
												</span>
												: <span className="badge bg-light text-muted border">—</span>
											}
										</td>
										<td className="text-center text-nowrap">{formatDate(item.created_at)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<div className="table-dropdown-item" onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>{t('edit')}
														</div>
														{canSeeHidden &&
															<div className="table-dropdown-item" onClick={() => toggleHidden(item)}>
																{isTrue(item.hidden_from_hr)
																	? <><i className="uil-eye"></i>{t('unhide_from_hr')}</>
																	: <><i className="uil-eye-slash"></i>{t('hide_from_hr')}</>
																}
															</div>
														}
														<div className="table-dropdown-item text-danger" onClick={() => deleteEmployee(item)}>
															<i className="uil-trash-alt"></i>{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination pagination={pagination} paginate={paginate} />
					}
				</div>
			</div>

			{/* CREATE/EDIT MODAL */}
			<Modal show={showModal} animation={false} centered size="xl" backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ? t('edit') : (t('create') + ' — ' + t('employees'))}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="row">
							{/* LEFT: xodim ma'lumotlari */}
							<div className="col-lg-5">
								{/* Rasm */}
								<div className="form-group">
									<label>{"Rasm"}</label>
									<div className="d-flex align-items-center gap-3">
										<div className="d-flex align-items-center justify-content-center"
											style={{ width: 76, height: 76, borderRadius: '50%', overflow: 'hidden', background: '#f1f3f5', flexShrink: 0 }}>
											{selectedItem.photo
												? <img
													src={selectedItem.photo.startsWith('data:') ? selectedItem.photo : `${IMG_BASE}/uploads/employees/${selectedItem.photo}`}
													alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
												: <i className="uil-user" style={{ fontSize: 34, color: '#adb5bd' }}></i>
											}
										</div>
										<div>
											<label className="btn btn-outline-primary btn-sm mb-1">
												<i className="uil-upload me-1"></i>Rasm qo'shish
												<input type="file" hidden accept="image/jpeg,image/jpg,image/png,image/webp"
													onChange={handlePhotoChange} />
											</label>
											{selectedItem.photo &&
												<button type="button" className="btn btn-outline-danger btn-sm ms-1 mb-1"
													onClick={removePhoto}>
													<i className="uil-trash-alt"></i>
												</button>
											}
											<div className="text-muted" style={{ fontSize: 11 }}>
												jpeg, jpg, png, webp · max 5MB
											</div>
											{photoError && <div className="text-danger" style={{ fontSize: 11 }}>{photoError}</div>}
										</div>
									</div>
								</div>

								<div className="form-group">
									<label>Ism familya<span className="required-mark">*</span></label>
									<input type="text" className="form-control" autoFocus
										value={selectedItem.name ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, name: e.target.value })} required />
								</div>

								<div className="form-group">
									<label>Lavozim</label>
									<Select
										options={employeeTypes}
										{...SELECT_PORTAL} value={employeeTypes.find(o => o.id === selectedItem.employee_type_id) || null}
										onChange={(opt) => setSelectedItem({ ...selectedItem, employee_type_id: opt?.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(o) => o.name}
										getOptionValue={(o) => o.id}
									/>
								</div>

								<div className="form-group">
									<label>Bo'lim</label>
									<Select
										options={departments}
										{...SELECT_PORTAL} value={departments.find(o => o.id === selectedItem.department_id) || null}
										onChange={(opt) => setSelectedItem({ ...selectedItem, department_id: opt?.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(o) => o.name}
										getOptionValue={(o) => o.id}
									/>
								</div>


								<div className="form-group">
									<label>Tel nomeri<span className="required-mark">*</span></label>
									<input type="number" className="form-control" placeholder="998901234567"
										value={selectedItem.phone ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, phone: e.target.value })} required />
								</div>

								{/* Telegram @username — chekni guruhga yuborishda shu xodimni ro'yxatdan
								    tanlab TEGLASH uchun. Bo'lim rahbarlariga to'ldirilsa, sotuvchi
								    ularni belgilaydi va chek e'tibordan chetda qolmaydi.
								    (Telegram Bot API guruh a'zolarini bermaydi, shuning uchun bir marta shu yerga yoziladi.) */}
								<div className="form-group">
									<label>{t('tg_username_field')}</label>
									<div className="input-group">
										<span className="input-group-text">@</span>
										<input type="text" className="form-control" placeholder="ali_valiyev"
											value={selectedItem.telegram_username ?? ''}
											onChange={(e) => setSelectedItem({ ...selectedItem, telegram_username: e.target.value.replace(/^@+/, '').trim() })} />
									</div>
									<div className="form-text">{t('tg_username_field_hint')}</div>
								</div>

								<div className="form-group mb-0">
									<label>Izoh</label>
									<textarea className="form-control" rows={2}
										value={selectedItem.note ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, note: e.target.value })} />
								</div>

							</div>

							{/* RIGHT: login + ruxsatlar */}
							<div className="col-lg-7">
								<div className="d-flex justify-content-between align-items-center p-2 mb-2 rounded"
									style={{ background: 'var(--dk-surface-2, #f8f9fa)', border: '1px solid #dee2e6' }}>
									<div>
										<span className="fw-semibold"><i className="uil-lock me-1"></i>Tizimga kirish huquqi</span>
										<div className="text-muted" style={{ fontSize: 11 }}>Login/parol va ruxsatlar (kassir, bo'lim rahbari)</div>
									</div>
									<div className="form-check form-switch">
										<input className="form-check-input" type="checkbox" style={{ cursor: 'pointer' }}
											checked={!!selectedItem.has_login}
											onChange={(e) => setSelectedItem({ ...selectedItem, has_login: e.target.checked })} />
									</div>
								</div>

								{selectedItem.has_login &&
									<>
										<div className="row">
											<div className="col-md-4">
												<div className="form-group">
													<label>Login<span className="required-mark">*</span></label>
													<input type="text" className="form-control"
														value={selectedItem.user_login ?? ''}
														disabled={selectedItem.has_existing_login}
														onChange={(e) => setSelectedItem({ ...selectedItem, user_login: e.target.value.replace(/\s+/g, '').toLowerCase() })} />
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<label>Parol{!selectedItem.id && <span className="required-mark">*</span>}</label>
													<input type="text" className="form-control"
														placeholder={selectedItem.id ? "O'zgartirmaslik uchun bo'sh" : ''}
														value={selectedItem.password ?? ''}
														onChange={(e) => setSelectedItem({ ...selectedItem, password: e.target.value })} />
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<label>Rol<span className="required-mark">*</span></label>
													<Select
														{...SELECT_PORTAL}
														options={ROLES}
														value={ROLES.find(o => o.key === selectedItem.role) || null}
														onChange={(opt) => setSelectedItem({ ...selectedItem, role: opt?.key })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(o) => o.label}
														getOptionValue={(o) => o.key}
													/>
												</div>
											</div>
										</div>

										{/* Ishlab chiqarish (sex) roli tanlansa — bo'lim ochiladi */}
										{roleSystemName(selectedItem.role) === 'ROLE_WORKSHOP' &&
											<div className="form-group">
												<label>Bo'lim (sex)<span className="required-mark">*</span></label>
												<Select
													{...SELECT_PORTAL}
													options={productTypes}
													value={productTypes.find(o => o.id === selectedItem.product_type) || null}
													onChange={(opt) => setSelectedItem({ ...selectedItem, product_type: opt?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(o) => o.name}
													getOptionValue={(o) => o.id}
												/>
											</div>
										}

										{/* Ishlab chiqarish RAHBARI — bir nechta bo'lim (nazorat qiladigan sexlar) */}
										{roleSystemName(selectedItem.role) === 'ROLE_PROD_MANAGER' &&
											<div className="form-group">
												<label>Bo'limlar (nazorat)<span className="required-mark">*</span></label>
												<Select
													{...SELECT_PORTAL}
													isMulti
													options={productTypes}
													value={productTypes.filter(o => (selectedItem.product_types || []).includes(o.id))}
													onChange={(opts) => setSelectedItem({ ...selectedItem, product_types: (opts || []).map(o => o.id) })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(o) => o.name}
													getOptionValue={(o) => o.id}
												/>
												<small className="text-muted">Bu bo'limlardagi cheklarni ko'radi va chop etadi.</small>
											</div>
										}

										{roleSystemName(selectedItem.role) === 'ROLE_CASHIER' && <>
										<h6 className="fw-bold mb-2 mt-1"><i className="uil-shield-check me-1"></i>Ruxsatlar</h6>
										<div style={{ maxHeight: '340px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: 4 }}>
											{permissions.map((category, catIndex) => (
												<div key={catIndex}>
													<div className="d-flex justify-content-between align-items-center cursor px-3 py-2"
														style={{ background: 'var(--dk-surface-2, #f8f9fa)', borderBottom: '1px solid #dee2e6' }}
														onClick={() => selectAll(!category.checked, catIndex)}>
														<span className="fw-semibold small">{category.name}</span>
														<input type="checkbox" className="form-check-input"
															checked={category.checked || false}
															onChange={(e) => { e.stopPropagation(); selectAll(e.target.checked, catIndex) }} />
													</div>
													{category.permissions.map((perm, permIndex) => (
														<div key={permIndex}
															className="d-flex justify-content-between align-items-center cursor px-3 py-1"
															style={{ borderBottom: '1px solid #f5f5f5' }}
															onClick={() => selectOne(!perm.checked, catIndex, permIndex)}>
															<span className="small" style={{ paddingLeft: perm.parent_id ? 16 : 0 }}>{perm.name_ru}</span>
															<input type="checkbox" className="form-check-input"
																checked={perm.checked || false}
																onChange={(e) => { e.stopPropagation(); selectOne(e.target.checked, catIndex, permIndex) }} />
														</div>
													))}
												</div>
											))}
											{permissions.length === 0 &&
												<div className="text-muted small p-3">{t('list_empty')}</div>
											}
										</div>
										</>}
									</>
								}

								{!selectedItem.has_login &&
									<div className="text-muted small p-3 text-center">
										<i className="uil-info-circle me-1"></i>
										Bu xodim tizimga kirmaydi (faqat maosh/davomat uchun).
									</div>
								}
							</div>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
